export default function AnshrAccountDeletion() {
    return (
      <div className="p-6 md:mx-auto max-w-4xl bg-gray-50 my-5 rounded-lg space-y-6">
        <h1 className="text-3xl font-bold flex justify-center">AnsHR Account Deletion</h1>
  
        <p>
          At AnsHR, we respect your right to request deletion of your account and associated data. 
          This page explains how you can request account deletion, what data will be deleted, 
          and what data must be retained for compliance purposes.
        </p>
  
        <h2 className="text-2xl font-semibold mt-4">How to Request Account Deletion</h2>
        <ul className="list-disc list-inside space-y-2">
          <li>Employees – Please contact your HR administrator if you want your account deleted.</li>
          <li>HR/Admin Users – You may submit account deletion requests for employees by contacting AnsHR support.</li>
          <li>Send your deletion request to <span className="text-blue-600">support@anstracknology.com</span> with your registered email ID and employee details.</li>
          <li>We will verify your request and confirm deletion within 30 days.</li>
        </ul>
  
        <h2 className="text-2xl font-semibold mt-4">Data That Will Be Deleted</h2>
        <p>When a valid deletion request is processed, we will delete:</p>
        <ul className="list-disc list-inside space-y-2">
          <li>Profile information (name, contact, employee ID)</li>
          <li>Login credentials (email, password)</li>
          <li>Attendance, leave, and work logs (not required by law)</li>
          <li>Internal communications and feedback records</li>
        </ul>
  
        <h2 className="text-2xl font-semibold mt-4">Data That Must Be Retained (as per Indian law)</h2>
        <p>
          Certain records cannot be deleted immediately because organizations are legally required to retain them for compliance, audit, and statutory purposes. These include:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>Payroll and salary records (10 years – Income Tax Act)</li>
          <li>Provident Fund (PF) and Employee State Insurance (ESI) records</li>
          <li>Statutory compliance and legal documents (as per applicable labour laws)</li>
        </ul>
        <p>
          These records are retained securely for the legally required period and are permanently erased once the retention period expires.
        </p>
  
        <h2 className="text-2xl font-semibold mt-4">Contact Us</h2>
        <p>If you have any questions or wish to request account deletion, please contact us:</p>
        <ul className="list-disc list-inside space-y-2">
          <li>📧 <span className="text-blue-600">support@anstracknology.com</span></li>
          <li>🌐 https://anshr.netlify.app/</li>
        </ul>
        <p>
          We aim to process verified deletion requests within 30 days, subject to statutory retention requirements.
        </p>
      </div>
    );
  };